import { z } from 'zod';

/**
 * Correct boolean parsing for URL query parameters.
 *
 * `z.coerce.boolean()` is a footgun for query strings: it runs `Boolean(value)`,
 * and `Boolean('false') === true` — every non-empty string is truthy. So a
 * caller sending `?flag=false` would have it parsed as `true`. This helper
 * parses the string explicitly: 'true' / '1' → true, 'false' / '0' → false
 * (and passes real booleans through untouched).
 *
 * Usage: `flag: boolFromQuery().optional()` or `boolFromQuery().default(false)`.
 */
export function boolFromQuery() {
  return z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((v) => (typeof v === 'string' ? v === 'true' || v === '1' : v));
}
